import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  channelMap: {},
};

const channelSlice = createSlice({
  name: "channel",
  initialState,
  reducers: {
    setChannelId: (state, action) => {
      const { url, id } = action.payload;
      state.channelMap[url] = id;
    },
    resetChannelMap: (state) => {
      state.channelMap = {};
    },
  },
});

export const { setChannelId, resetChannelMap } = channelSlice.actions;
export default channelSlice.reducer;
